"use client";

import { DragEvent, useCallback, useState } from "react";

export function useFileDropTarget(
  ref: React.RefObject<HTMLDivElement | null>,
  dropEvent?: (event: DragEvent) => void
) {
  const [isDropTargetActive, setIsDropTargetActive] = useState(false);

  const handleDragOver = useCallback((event: DragEvent) => {
    event.preventDefault();
  }, []);

  const handleDragEnter = useCallback(
    (event: DragEvent) => {
      event.preventDefault();
      if (!ref.current?.contains(event.relatedTarget as Node)) {
        setIsDropTargetActive(true);
      }
    },
    [ref]
  );

  const handleDragLeave = useCallback(
    (event: DragEvent) => {
      event.preventDefault();
      if (!ref.current?.contains(event.relatedTarget as Node)) {
        setIsDropTargetActive(false);
      }
    },
    [ref]
  );

  const handleDrop = useCallback(
    (event: DragEvent) => {
      event.preventDefault();
      dropEvent?.(event);
      setIsDropTargetActive(false);
    },
    [dropEvent]
  );

  if (!dropEvent) {
    return {
      dropTargetProps: {},
      isDropTargetActive,
    };
  }

  return {
    dropTargetProps: {
      onDragOver: handleDragOver,
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
    },
    isDropTargetActive,
  };
}
